import { render } from "./AccessAlert.vue?vue&type=template&id=69ec66ed"
const script = {}

import "./AccessAlert.vue?vue&type=style&index=0&id=69ec66ed&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__